var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiFooter',{attrs:{"footer-items":_vm.footerMenu,"contact-data":_vm.footerContactData,"social-icons":_vm.footerSocialMenu,"logo-url":_vm.logoUrl,"i18n":_vm.footerTranslations}})}
var staticRenderFns = []

export { render, staticRenderFns }